import type { NewRequestServices } from "../../../model/services.model";
import type { NewRequestState } from "../../../model/form.model";
import type { FormikInitialValuesNewRequest } from "../../../model/form.model";

import { validateOrder } from "../../../domain/validators/validateOrder";
import { toCreateOrderPayload } from "../../mappers/toCreateOrderPayload";

import { ICreateOrderDataDTO } from "@modules/orders/dtos/ICreateOrderDataDTO";
import { CreateOrderResultUI } from "@pages/User/NewRequestV2/model/order.model";
import { toCreateOrderResponse } from "../../mappers/toCreateOrderResponse";

export async function submitCreateOrder(args: {
  services: NewRequestServices;
  state: NewRequestState;
  values: FormikInitialValuesNewRequest;
  useV2?: boolean;
}): Promise<CreateOrderResultUI> {
  const { services, state, values, useV2 } = args;

  const customerSelected = Boolean(state.purchase.customer?.id);
  const cart = state.products.cart;
  const pricingStatus = state.products.pricingStatus;

  const v = validateOrder({
    purchase: values.purchase,
    cart,
    pricingStatus,
    customerSelected,
  });

  if (!v.ok)
    return {
      ok: false,
      reason: v.reason,
      created: [],
      overall: "ERRO",
      failed: [],
      raw: null,
    };

  const customer = state.purchase.customer!;
  const payload = toCreateOrderPayload({ values, customer, cart });

  try {
    const dto: ICreateOrderDataDTO =
      useV2 && services.createOrderService.executeV2
        ? await services.createOrderService.executeV2(payload)
        : await services.createOrderService.execute(payload);

    return toCreateOrderResponse(dto, cart);
  } catch (err) {
    return {
      ok: false,
      reason: extractApiMessage(err),
      created: [],
      failed: [],
      overall: "ERRO",
      raw: null,
    };
  }
}

function extractApiMessage(err: unknown): string {
  const anyErr = err as any;

  const msg =
    anyErr?.response?.data?.message ||
    anyErr?.response?.data?.error ||
    anyErr?.message;

  return typeof msg === "string" && msg.trim()
    ? msg
    : "Não foi possível concluir o pedido. Tente novamente.";
}
